const reservationStatus = {
  available: 'AVAILABLE',
  unavailable: 'NOT_AVAILABLE',
  reservedSyntec: 'RESERVED_SYNTEC',
}
export default reservationStatus
